<template>
	<el-table 
		class="jc-datashow-list jc-datashow-list-inline" :data="eventLogs" 
		v-loading="loading">
		<el-table-column prop="logid" min-width="60" :label="$t('detail.text.logid')"></el-table-column>
		<el-table-column prop="alertType" :label="$t('detail.text.alertType')"></el-table-column>
		<el-table-column prop="alertDesc" min-width="200" :label="$t('detail.text.alertDesc')"></el-table-column>
		<el-table-column prop="eventTime" :label="$t('detail.text.eventTime')"></el-table-column>
		<el-table-column prop="updateTime" :label="$t('detail.text.updateTime')"></el-table-column>
		<el-table-column prop="count" min-width="60" :label="$t('detail.text.count')"></el-table-column>
		<el-table-column prop="alertStatus" :label="$t('detail.text.alertStatus')"
		>
			<template slot-scope="scope">
                <span :class="{'undeal': scope.row.status === 0, 'recover': scope.row.status === 1, 'ignore': scope.row.status === 2}">{{alarmStatusConstant[scope.row.status]}}</span>
            </template>
		</el-table-column>
	</el-table>
</template>
<script>
import {alarmStatusConstant} from '@/common/Constants';
export default {
    name: 'AlarmLogs',
    props: {
        eventLogs: {
            type: Array,
            default: []
        },
        loading: {
        	type: Boolean,
        	default: false
        }
    },
    data() {
        return {
            alarmStatusConstant: alarmStatusConstant,
        };
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    methods: {
    },
};
</script>

<style lang="sass">
    @import "./style"
</style>


// WEBPACK FOOTER //
// src/components/common/alarmLogs/AlarmLogs.vue